import { createContext, useContext } from 'react';

interface ThemeModeContextValue {
  mode: 'light' | 'dark';
  toggleTheme: () => void;
}

export const ThemeModeContext = createContext<ThemeModeContextValue>({
  mode: 'dark',
  toggleTheme: () => {},
});

export function useThemeMode() {
  return useContext(ThemeModeContext);
}
